import React, { useEffect } from 'react';
import { Modal as AntdModal } from 'antd';
import { ModalProps as AntdModalProps } from 'antd/lib/modal';
import { useHistory } from 'react-router-dom';
import { Color } from '@bb/elements-web';

export type ModalProps = AntdModalProps;

export const Modal = (props: ModalProps) => {
  const history = useHistory();

  useEffect(() => {
    if (history) {
      const unlisten = history.listen(() => {
        Modal.destroyAll();
      });

      return () => {
        unlisten();
      };
    }
  }, [history]);

  const { okButtonProps } = props;

  return (
    <AntdModal
      data-cy="modal-popup"
      {...props}
      okButtonProps={{
        ...okButtonProps,
        ...(!okButtonProps?.disabled && {
          style: {
            backgroundColor: Color.PRIMARY,
            borderColor: Color.PRIMARY,
          },
        }),
      }}
    />
  );
};

Modal.confirm = AntdModal.confirm;
Modal.destroyAll = AntdModal.destroyAll;
Modal.error = AntdModal.error;
Modal.info = AntdModal.info;
Modal.warning = AntdModal.warning;
Modal.warn = AntdModal.warn;
Modal.success = AntdModal.success;

/** @deprecated import Modal from bb/elements-web instead */
export default Modal;
